import React from 'react';
import axios from 'axios';

export default class PersonList extends React.Component {
  state = {
    persons: []
  }

  componentDidMount() {
    axios.get(`https://www.cbioportal.org/api/cancer-types?direction=ASC&pageNumber=0&pageSize=100&projection=SUMMARY`)
      .then(res => {
        const persons = res.data;
        this.setState({ persons });
      })
  }

  render() {
    return (
      <ul>
        {
          this.state.persons
            .map(person =>
              <li key={person.name}>{person.name}</li>
            )
        }
      </ul>
    )
  }
}